import { useMemo, type ReactNode } from "react";

import { useContextMenu } from "../../../elements/context-menu/hooks";

import styles from "./navbar-links-item.module.css";

export type NavbarLinksItemProps = {
  children: ReactNode;
} & React.AllHTMLAttributes<HTMLDivElement>;

export function NavbarLinksItem({ children, ...props }: NavbarLinksItemProps) {
  const { isOpen } = useContextMenu();

  const className = useMemo(() => {
    if (isOpen) {
      return `${styles.MenuItem} ${styles.IsOpen}`;
    }

    return `${styles.MenuItem}`;
  }, [isOpen]);

  return (
    <div className={className} {...props}>
      {children}
    </div>
  );
}
